import { IRebalancedPayload } from './../../../models/plannedPortfolios';
import { IPlannedPortfolioPayload, IPlannedPortfolio } from '../../../models/plannedPortfolios';
import { Action } from '@ngrx/store';

export enum PlannedPortfoliosActionTypes {
    SELECT_PLANNED_PORTFOLIO = 'SELECT_PLANNED_PORTFOLIO',
    SELECT_PLANNED_PORTFOLIO_SUCCESS = 'SELECT_PLANNED_PORTFOLIO_SUCCESS',
    SELECT_PLANNED_PORTFOLIO_FAIL = 'SELECT_PLANNED_PORTFOLIO_FAIL',
    SELECT_EXISTING_PLANNED_PORTFOLIO_SUCCESS = 'SELECT_EXISTING_PLANNED_PORTFOLIO_SUCCESS',
    SELECT_TEMP_PLANNED_PORTFOLIO = 'SELECT_TEMP_PLANNED_PORTFOLIO',
    SELECT_TEMP_PLANNED_PORTFOLIO_SUCCESS = 'SELECT_TEMP_PLANNED_PORTFOLIO_SUCCESS',
    SELECT_TEMP_PLANNED_PORTFOLIO_FAIL = 'SELECT_TEMP_PLANNED_PORTFOLIO_FAIL',
    CANCEL_TEMPORARY_PLANNED_PORTFOLIO = 'CANCEL_TEMPORARY_PLANNED_PORTFOLIO',
    SUBMIT_PLANNED_PORTFOLIO = 'SUBMIT_PLANNED_PORTFOLIO',
    SUBMIT_PLANNED_PORTFOLIO_SUCCESS = 'SUBMIT_PLANNED_PORTFOLIO_SUCCESS',
    RESET_PLANNED_PORTFOLIO = 'RESET_PLANNED_PORTFOLIO',
    SET_EXISTING_PLANNED_PORTFOLIO = 'SET_EXISTING_PLANNED_PORTFOLIO',
    SET_SELECTED_SUBSCRIPTION_ID = 'SET_SELECTED_SUBSCRIPTION_ID',
    PLANNED_PORTFOLIOS_DATA_ERROR = 'PLANNED_PORTFOLIOS_DATA_ERROR'
}

export class SelectPlannedPortfolio implements Action {
    readonly type = PlannedPortfoliosActionTypes.SELECT_PLANNED_PORTFOLIO;
    constructor(public payload: IPlannedPortfolioPayload) { }
}
export class SelectPlannedPortfolioSuccess implements Action {
    readonly type = PlannedPortfoliosActionTypes.SELECT_PLANNED_PORTFOLIO_SUCCESS;
    constructor(public payload: IRebalancedPayload) { }
}
export class SelectPlannedPortfolioFail implements Action {
    readonly type = PlannedPortfoliosActionTypes.SELECT_PLANNED_PORTFOLIO_FAIL;
    constructor(public payload: IRebalancedPayload) { }
}
export class SelectExistingPlannedPortfolioSuccess implements Action {
    readonly type = PlannedPortfoliosActionTypes.SELECT_EXISTING_PLANNED_PORTFOLIO_SUCCESS;
}
export class SelectTemporaryPlannedPortfolio implements Action {
    readonly type = PlannedPortfoliosActionTypes.SELECT_TEMP_PLANNED_PORTFOLIO;
    constructor(public payload: IPlannedPortfolio) { }
}
export class SetExistingPlannedPortfolio implements Action {
    readonly type = PlannedPortfoliosActionTypes.SET_EXISTING_PLANNED_PORTFOLIO;
    constructor(public payload: number) { }
}
export class SelectTempPlannedPortfolioSuccess implements Action {
    readonly type = PlannedPortfoliosActionTypes.SELECT_TEMP_PLANNED_PORTFOLIO_SUCCESS;
    constructor(public payload: IRebalancedPayload) { }
}
export class SelectTempPlannedPortfolioFail implements Action {
    readonly type = PlannedPortfoliosActionTypes.SELECT_TEMP_PLANNED_PORTFOLIO_FAIL;
    constructor(public payload: IRebalancedPayload) { }
}
export class CancelTemporaryPlannedPortfolio implements Action {
    readonly type = PlannedPortfoliosActionTypes.CANCEL_TEMPORARY_PLANNED_PORTFOLIO;
    constructor(public payload: number) { }
}
export class SubmitPlannedPortfolio implements Action {
    readonly type = PlannedPortfoliosActionTypes.SUBMIT_PLANNED_PORTFOLIO;
    constructor(public payload: IPlannedPortfolio) { }
}
export class SubmitPlannedPortfolioSuccess implements Action {
    readonly type = PlannedPortfoliosActionTypes.SUBMIT_PLANNED_PORTFOLIO_SUCCESS;
    constructor(public payload: IPlannedPortfolio) { }
}
export class ResetPlannedPortfolio implements Action {
    readonly type = PlannedPortfoliosActionTypes.RESET_PLANNED_PORTFOLIO;
}
export class SetSelectedSubscriptionId implements Action {
    readonly type = PlannedPortfoliosActionTypes.SET_SELECTED_SUBSCRIPTION_ID;
    constructor(public payload: number) {}
}
export class PlannedPortfoliosDataError implements Action {
    readonly type = PlannedPortfoliosActionTypes.PLANNED_PORTFOLIOS_DATA_ERROR;
    constructor(public payload: any) { }
}

export type PlannedPortfoliosActions = SelectPlannedPortfolio | SelectPlannedPortfolioSuccess | SelectPlannedPortfolioFail | SetExistingPlannedPortfolio | SelectExistingPlannedPortfolioSuccess |
    SubmitPlannedPortfolio | SubmitPlannedPortfolioSuccess | SelectTemporaryPlannedPortfolio | SelectTempPlannedPortfolioSuccess | SelectTempPlannedPortfolioFail |
    CancelTemporaryPlannedPortfolio | ResetPlannedPortfolio | SetSelectedSubscriptionId | PlannedPortfoliosDataError;
